var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlarmClicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.269531,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 26.7422H34V29.5422H6V26.7422H8.8V16.9422C8.8 13.9718 9.98 11.123 12.0804 9.02259C14.1808 6.92218 17.0296 5.74219 20 5.74219C22.9704 5.74219 25.8192 6.92218 27.9196 9.02259C30.02 11.123 31.2 13.9718 31.2 16.9422V26.7422ZM28.4 26.7422V16.9422C28.4 14.7144 27.515 12.5778 25.9397 11.0025C24.3644 9.42719 22.2278 8.54219 20 8.54219C17.7722 8.54219 15.6356 9.42719 14.0603 11.0025C12.485 12.5778 11.6 14.7144 11.6 16.9422V26.7422H28.4ZM15.8 32.3422H24.2V35.1422H15.8V32.3422Z",
    fill: "#1167ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmClicked);
export default __webpack_public_path__ + "static/media/icon_alarm_clicked.a85e1b5c1b01080ca26961112ac93106.svg";
export { ForwardRef as ReactComponent };